<template>
  <div v-if="modalState" class="diag-full animated fadeInUp">
    <div class="div-close text-xs-right">
      <button @click="closeDiag()" aria-label="Cerrar contenido" class="hvr-grow">
        <v-icon class="font-red">fa-times </v-icon>
      </button>
    </div>
    <div class="diag-cont">
      <div slot="texto">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalState: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeDiag() {
      this.$emit("hide");
    }
  },
  updated() {
    var bodyTag = document.getElementsByTagName("BODY")[0];
    if (this.modalState) {
      bodyTag.style.overflow = "hidden";
    } else {
      bodyTag.style.overflow = "auto";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass//helpers/variables";

.diag-full {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  overflow: auto;
  .diag-cont {
    width: 100%;
    max-width: 1200px;
    margin: auto;
    padding: 5px 60px;
  }
  .div-close {
    width: 100%;
    height: 50px;
    max-width: 1200px;
    padding: 10px;
    margin: 120px auto 10px auto;
    .icon {
      font-size: 50px;
    }
  }
}

.application.theme--light {
  &.light {
    .diag-full {
      background-color: white;
    }
  }
  &.dark {
    .diag-full {
      background-color: $black-dav;
    }
  }
}
</style>




// WEBPACK FOOTER //
// Diagfull.vue?13be8122